<template>
  <div class="page">
   <img src="../assets/jnm-licence.jpg"/>
  </div>
</template>

<script>
export default {
  name: "SkillPrivatepolicy",
  data() {
    return {
     
           
      
      
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
.page {
  display: block;
  width: 6.9rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  /* padding-right: 0.3rem;
  padding-left: 0.3rem; */
}
img{
  width: 100%;
  height:auto;
}

</style>


// WEBPACK FOOTER //
// src/components/JnmLicence.vue